var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#111","d":"M26.5 13.25C26.5 5.93 20.57 0 13.25 0S0 5.93 0 13.25c0 6.52 4.74 12.07 11.18 13.09v-9.26H7.82v-3.83h3.36v-2.92c0-3.32 1.98-5.16 5.01-5.16.99.01 1.98.1 2.97.26V8.7h-1.67a1.915 1.915 0 0 0-2.16 2.07v2.49H19l-.59 3.83h-3.09v9.26c6.44-1.03 11.18-6.58 11.18-13.1z","key":0}),React.createElement("path",{"fill":"none","d":"m18.41 17.08.59-3.83h-3.68v-2.49c-.09-1.05.68-1.98 1.74-2.08.14-.01.28-.01.42.01h1.67V5.43c-.98-.16-1.97-.25-2.97-.26-3.03 0-5.01 1.83-5.01 5.16v2.92H7.82v3.83h3.36v9.26c1.37.21 2.77.21 4.14 0v-9.26h3.09z","key":1})]);
}

Facebook.defaultProps = {"viewBox":"0 0 26.5 26.5","xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
